import { render, staticRenderFns } from "./landlordDetails.vue?vue&type=template&id=66b900f3&scoped=true&"
import script from "./landlordDetails.vue?vue&type=script&lang=js&"
export * from "./landlordDetails.vue?vue&type=script&lang=js&"
import style0 from "./landlordDetails.vue?vue&type=style&index=0&id=66b900f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b900f3",
  null
  
)

export default component.exports